import { FunctionComponent } from 'react'

import { Heading, Text } from '@theme-ui/components'
import { useTranslation, Trans } from 'react-i18next'

import styled from 'styled-components'

import { space } from '@fairhq/common'
import { ErrorLayout } from 'layout/ErrorLayout'

const Padding = styled.span`
  padding-bottom: ${space[5]}px;
  display: block;
`

export const Maintenance: FunctionComponent = () => {
  const { t } = useTranslation()
  return (
    <ErrorLayout>
      <Heading variant="h1">{t('maintenance.title')}</Heading>
      <Text as="div" variant="bodyLarge">
        <Trans i18nKey="maintenance.description" components={[<Padding />]} />
      </Text>
    </ErrorLayout>
  )
}
